import React from 'react';
import { Field, Form, Formik } from 'formik';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './contact.scss';

export default function ContactForm() {
    return (
        <section className="deneb_contact cantact_v2 section_padding">
            <div className="container">
                <div className="row">
                    <div className="col-lg-7">
                        <div className="section_title">
                            <h2>Send us a message</h2>
                            <p>Give us a call or drop by anytime, we endeavour to answer all enquiries within 24 hours on business days. We will be happy to answer your questions.</p>
                        </div>
                        <div className="contact_form">
                            <Formik
                                initialValues={{
                                    first_name: '',
                                    last_name: '',
                                    email_address: '',
                                    phone_number: '',
                                    project_title: '',
                                    selected_option: '',
                                    user_message: ''
                                }}
                                onSubmit={(values, actions) => {
                                    setTimeout(() => {
                                        console.log(JSON.stringify(values, null, 2));
                                        actions.setSubmitting(false);
                                    }, 1000);
                                }}
                            >
                                {() => (
                                    <Form>
                                        <div className="row">
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field
                                                      type="text"
                                                      name="first_name"
                                                      className="form_control"
                                                      placeholder="First name"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field
                                                      type="text"
                                                      name="last_name"
                                                      className="form_control"
                                                      placeholder="Last name"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field
                                                      type="email"
                                                      name="email_address"
                                                      className="form_control"
                                                      placeholder="Email"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field
                                                      type="number"
                                                      name="phone_number"
                                                      className="form_control"
                                                      placeholder="Phone"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field
                                                      type="text"
                                                      name="project_title"
                                                      className="form_control"
                                                      placeholder="Project Title"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="form_group">
                                                    <Field name="selected_option" as="select">
                                                        <option value="">Choose Service</option>
                                                        <option value="design">Web & Graphic Design</option>
                                                        <option value="development">Apps And Web Development</option>
                                                        <option value="ai">AI Development</option>
                                                        <option value="saas">SaaS Development</option>
                                                        <option value="consultation">Consultation</option>
                                                        <option value="marketing">SEO and marketing</option>
                                                    </Field>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="form_group">
                                                    <Field
                                                      as="textarea"
                                                      name="user_message"
                                                      className="form_control"
                                                      placeholder="Your Message"
                                                      required
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="button_box">
                                                <button className="deneb_btn">Submit Now</button>
                                            </div>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className="contact_details">
                            <div className="contact_details_card">
                                <div className="details_title">
                                    <h3>Get In Touch</h3>
                                </div>
                                <div className="single_info">
                                    <div className="icon">
                                        <i><FaPhoneAlt /></i>
                                    </div>
                                    <div className="info">
                                        <h5>Phone</h5>
                                        <p><a href="tel:+12498787233">+1 249-878-7233</a></p>
                                        <p><a href="tel:+917600747503">+91 76007-47503</a></p>
                                    </div>
                                </div>
                                <div className="single_info">
                                    <div className="icon">
                                        <i><FaEnvelope /></i>
                                    </div>
                                    <div className="info">
                                        <h5>Email</h5>
                                        <p><a href="mailto:info@riseuptechnology.ca">info@riseuptechnology.ca</a></p>
                                        <p><a href="mailto:info@riseuptechnology.com">info@riseuptechnology.com</a></p>
                                    </div>
                                </div>
                                <div className="single_info">
                                    <div className="icon">
                                        <i><FaMapMarkerAlt /></i>
                                    </div>
                                    <div className="info">
                                        <h5>Canada Office</h5>
                                        <p>57 Purple Sage Dr, Brampton,<br /> ON, Canada, L6P 4P5.</p>
                                    </div>
                                </div>
                                <div className="single_info">
                                    <div className="icon">
                                        <i><FaMapMarkerAlt /></i>
                                    </div>
                                    <div className="info">
                                        <h5>India Office</h5>
                                        <p>E-402 Pramukh Heights, Surat<br /> Gujarat, India, 394107.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
